// extracted by mini-css-extract-plugin
module.exports = {"voteCell":"post-vote_voteCell__3poHM","voteButton":"post-vote_voteButton__1lYnM","voted":"post-vote_voted__2czAB","score":"post-vote_score__3yfVa"};